import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-share-report-dialog',
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        TranslateModule
    ],
    standalone: true,
    templateUrl: './share-report-dialog.component.html',
    styleUrl: './share-report-dialog.component.scss'
})

export class ShareReportDialogComponent implements OnInit {
  isTheme: string = "light";
  isFilter: string = "false";
  theme: string = "#1b1b1b";
  filter: any;
  url: any;
  noFilter: boolean = false;
  icon: string = "";

  constructor(
    public dialogRef: MatDialogRef<ShareReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private clipboard: Clipboard) {
    if (data.icon) this.icon = data.icon;
    if (data.noFilter) this.noFilter = data.noFilter;
    if (data.filter) this.filter = data.filter;
    if (data.url) this.url = data.url;
  }

  ngOnInit() {
    this.updateUrl();
  }

  updateUrl() {
    const url = new URL(this.url);

    if (this.isTheme == "dark") {
      url.searchParams.set('backgroundColor', this.theme);
    } else {
      url.searchParams.delete('backgroundColor');
    }

    if (this.isFilter == "true") {
      url.searchParams.set('filters', encodeURIComponent(this.filter));
    } else {
      url.searchParams.delete('filters');
    }

    this.data.url = url.toString();
  }

  dismiss(): void {
    this.data.dismissed = true
    this.dialogRef.close(this.data);
  }

  ok(): void {
    this.dialogRef.close();
  }
  copy() {
    this.clipboard.copy(this.data.url)
  }
  open() {
    window.open(this.data.url)
  }

}
